import styled from '@emotion/styled';
import { BREAKPOINTS_LEGACY } from '@sortlist-frontend/design-system/legacy';

export const Header = styled.div`
  text-align: left;
  padding-bottom: 4rem;

  @media only screen and (min-width: ${BREAKPOINTS_LEGACY.xs}) {
    text-align: center;
    padding-bottom: 12rem;
    h1 {
      font-size: 4rem;
    }
  }
`;
